import { CheckCircle2, Info, AlertTriangle, XCircle, Loader2, AlertCircle, type LucideIcon } from "lucide-react";
import type { ToastType } from "./types";

export const TOAST_ICONS: Record<ToastType, LucideIcon> = {
  success: CheckCircle2,
  info: Info,
  warning: AlertTriangle,
  "error-soft": XCircle,
  "error-hard": XCircle,
  progress: Loader2,
  partial: AlertCircle,
};

export const TOAST_COLORS: Record<ToastType, { icon: string; accent: string }> = {
  success: {
    icon: "hsl(152 60% 30%)",
    accent: "hsl(152 60% 96%)",
  },
  info: {
    icon: "hsl(214 72% 40%)",
    accent: "hsl(214 72% 97%)",
  },
  warning: {
    icon: "hsl(32 80% 35%)",
    accent: "hsl(38 92% 96%)",
  },
  "error-soft": {
    icon: "hsl(0 72% 42%)",
    accent: "hsl(0 72% 97%)",
  },
  "error-hard": {
    icon: "hsl(0 72% 38%)",
    accent: "hsl(0 72% 96%)",
  },
  progress: {
    icon: "hsl(214 72% 40%)",
    accent: "hsl(214 72% 97%)",
  },
  partial: {
    icon: "hsl(32 80% 35%)",
    accent: "hsl(38 92% 96%)",
  },
};
